import { colors, type TableConfig } from '@innovationdepartment/proxima-ui';
import type { BrandProductMetricAttributes } from 'types/brandProducts';
import BrandProductsEmptyState from './BrandProducts.EmptyState';
import cellRenderer from './brandProductsCellRenderer';

type ConfigProps = {
  onProductRowSelect: (product: BrandProductMetricAttributes) => void;
  selectedProducts: BrandProductMetricAttributes[];
  loading: boolean;
};

const getConfig = (props: ConfigProps): TableConfig<BrandProductMetricAttributes> => {
  const { onProductRowSelect, loading, selectedProducts } = props;

  return {
    rowColor: product =>
      selectedProducts.some(p => p.productId === product.productId) ? colors.green0 : undefined,
    onRowClick: product => onProductRowSelect(product),
    cellRenderer: opts => cellRenderer(opts),
    columns: {
      order: [
        'title',
        'itemsPurchased',
        'averagePriceUsd',
        'totalRevenueUsd',
        'revenuePercentage',
        'classificationScore'
      ],
      title: {
        label: 'Product name',
        width: 500
      },
      itemsPurchased: {
        label: 'Items sold',
        align: 'right'
      },
      averagePriceUsd: {
        label: 'Avg price (USD)',
        align: 'right'
      },
      totalRevenueUsd: {
        label: 'Total revenue (USD)',
        align: 'right'
      },
      revenuePercentage: {
        label: 'Revenue %',
        align: 'right'
      },
      classificationScore: {
        label: 'Score',
        align: 'right'
      }
    },
    emptyStateRenderer: () => <BrandProductsEmptyState loading={loading} />
  };
};

export default getConfig;
